import React from 'react';

import { SecondaryButton } from '../secondary-button';
import { QUESTIONS, SECTION_TYPES } from '../../models/InfoAndQuestions';
import styles from './InformationAndQuestions.css';

const renderInformationSection = (element) => {
  const boldClass = element.boldDescription ? styles.boldDescription : '';
  const italicClass = element.italicDescription ? styles.italicDescription : '';
  const underlineClass = element.underlineDescription ? styles.underlineDescription : '';

  const labelPresent = element.label !== '-' && element.label;
  const rowDescriptionClass = labelPresent ?
    styles.rowDescriptionWithLabel : styles.rowDescriptionFull;

  return (
    <div key={element.order} className={styles.infoRow}>
      {
        labelPresent &&
        <span className={styles.rowLabel}>{element.label}</span>
      }
      <span className={[rowDescriptionClass, boldClass, italicClass, underlineClass].join(' ')}>
        {element.description}
      </span>
    </div>
  );
};

const renderQuestion = (question, props) => {
  switch (question) {
    case QUESTIONS.acceptQuestion:
      return (
        <div key={question} className={styles.questionContainer}>
          {props.children}
          <div className={styles.answerSection}>
            <SecondaryButton
              className={styles.answerButton}
              onClick={event => props.onActionQuestion(event, question, true)}
            >
              {props.options.acceptQuestion.message}
            </SecondaryButton>
          </div>
        </div>
      );
    case QUESTIONS.cancelQuestion:
      return (
        <div key={question} className={styles.questionContainer}>
          {props.children}
          <div className={styles.answerSection}>
            <SecondaryButton
              className={styles.answerButton}
              onClick={event => props.onActionQuestion(event, question, false)}
            >
              {props.options.cancelQuestion.message}
            </SecondaryButton>
          </div>
        </div>
      );
    case QUESTIONS.disposalQuestion:
      return (
        <div key={question} className={styles.questionContainer}>
          {props.children}
          <div className={styles.answerSection}>
            <SecondaryButton
              className={styles.answerButton}
              onClick={event => props.onActionQuestion(event, question, false)}
            >
              {props.options.disposalQuestion.message}
            </SecondaryButton>
          </div>
        </div>
      );
    case QUESTIONS.regretQuestion:
      return (
        <div key={question} className={styles.questionContainer}>
          {props.children}
          <div className={styles.answerSection}>
            <SecondaryButton
              className={styles.answerButton}
              onClick={event => props.onActionQuestion(event, question, true)}
            >
              {props.options.regretQuestion.message}
            </SecondaryButton>
          </div>
        </div>
      );
    case QUESTIONS.oneWeekQuestion:
      return (
        <div key={question} className={styles.questionContainer}>
          {props.children}
          <div className={styles.answerSection}>
            <SecondaryButton
              className={styles.answerButton}
              onClick={event => props.onActionQuestion(event, question, false)}
            >
              {props.options.oneWeekQuestion.message}
            </SecondaryButton>
          </div>
        </div>
      );
    default:
      return null;
  }
};

const InformationAndQuestions = props => props.sections.map((section) => {
  switch (section.type) {
    case SECTION_TYPES.question:
      return renderQuestion(section.question, props);
    case SECTION_TYPES.information:
      return renderInformationSection(section);
    default:
      return null;
  }
});

export { InformationAndQuestions };



// WEBPACK FOOTER //
// ./src/common/information-and-questions/InformationAndQuestions.jsx